import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import {
  Logout,
  Settings,
  AdminPanelSettings,
  School,
  BedroomBaby,
} from "@mui/icons-material";

import MyAvatar from "./MyAvatar";
import StyledTooltip from "../../../tooltips/StyledTooltip";
import { useAppContext } from "../../../context/appContext";

function AppBarAction({ title, onClick, icon }) {
  return (
    <StyledTooltip title={title} placement="bottom" arrow>
      <span>
        <IconButton onClick={onClick}>{icon}</IconButton>
      </span>
    </StyledTooltip>
  );
}

function KsbItAppBarRight() {
  const {
    currentUser,
    isAnAdmin,
    isAuthenticated,
    logout,
    isTeacherView,
    setIsTeacherView,
    isStudentView,
    setIsStudentView,
    isMobile,
  } = useAppContext();

  const navigate = useNavigate();

  const isLoggedIn = isAuthenticated && currentUser;

  if (!isLoggedIn) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "flex-end",
        alignItems: "center",
        // gap: 1,
        // pr: 1,
      }}
    >
      {/* Avatar */}
      <MyAvatar
        change={() => navigate("/profil")}
        tooltipText="Profil"
        ariaLabel="Profilseite"
      />

      {/* Settings (desktop only) */}
      {isAnAdmin && !isMobile && (
        <AppBarAction
          title="Einstellungen"
          onClick={() => navigate("/einstellungen")}
          icon={<Settings />}
        />
      )}

      {/* Teacher toggle */}
      {isAnAdmin && (
        <AppBarAction
          title={isTeacherView ? "zur Adminsicht" : "zur Lehrersicht"}
          onClick={() => setIsTeacherView((prev) => !prev)}
          icon={isTeacherView ? <AdminPanelSettings /> : <School />}
        />
      )}

      {isAnAdmin && (
        <AppBarAction
          title={isStudentView ? "zur Adminsicht" : "zur Schülersicht"}
          onClick={() => setIsStudentView((prev) => !prev)}
          icon={isStudentView ? <AdminPanelSettings /> : <BedroomBaby />}
        />
      )}

      {/* Logout */}
      <AppBarAction title="Logout" onClick={logout} icon={<Logout />} />
    </Box>
  );
}

export default memo(KsbItAppBarRight);
